import { render, staticRenderFns } from "./screenshotOne.vue?vue&type=template&id=09f2ae98&"
import script from "./screenshotOne.vue?vue&type=script&lang=js&"
export * from "./screenshotOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports